import { Identifier } from "../../id";
export class MenuSectionId extends Identifier {
    constructor(id) {
        super("MenuSectionId", id);
    }
}
